import { ApplicationRef, inject, Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  socket = inject(Socket);
  appRef = inject(ApplicationRef);

  constructor() {
    const loginResponse = JSON.parse(localStorage.getItem('loginResponse') || '');
    const userId = loginResponse.contracts[0].id;
    if (!userId) {
      console.error('User ID is not available in localStorage!');
      return;
    }
    const url = `${environment.SOCKET_BASE_URL}?id=${userId}`;
    const accessToken = localStorage.getItem('accessToken'); // Or wherever your token is stored

    // Dynamically initialize the socket
    this.socket = new Socket({
      url,
      options: {
      }
    }, this.appRef);
    
    this.socket.connect();

    // Handle socket events
    this.socket.fromEvent('connect').subscribe(() => {
      console.log('Socket connected successfully!');
    });

    this.socket.fromEvent('connect_error').subscribe((err: any) => {
      console.error('Socket connection error:', err);
    });

    this.socket.fromEvent('disconnect').subscribe(() => {
      console.log('Socket disconnected');
    });
   }

  /**
   * Listens for an event with the specified name on the socket.
   *
   * @param event The name of the event to listen for.
   * @returns An Observable that emits the event data when the event occurs.
   *
   * Note: This observable will automatically unsubscribe from the event when
   * the observable is complete or unsubscribed from.
   */
    on(event: string): Observable<any> {
      return new Observable((observer) => {
        this.socket.on(event, (data: any) => {
          console.log('data', data);        
          observer.next(data);
        });
        return () => {
          this.socket.off(event);
        }
      })
    }
}
